import {
  TREASURE_VALUES, HAZARDS, COPIES_PER_HAZARD, ARTIFACT_COUNT, CARD_KINDS,
} from './constants';

// The 35 physical cards, built once and then only ever referenced by id.
//
// A card's `id` is also the name of its art file (`public/card-art/<id>.jpg`),
// which is what scripts/extractCardArt.mjs writes. Ids are therefore stable
// forever: renaming one silently breaks an image.

export const treasureCards = () => TREASURE_VALUES.map((value, i) => ({
  id: `t${i}`,
  kind: CARD_KINDS.TREASURE,
  value,
}));

export const hazardCards = () => HAZARDS.flatMap((hazard) => (
  Array.from({ length: COPIES_PER_HAZARD }, (_, copy) => ({
    id: `${hazard}${copy}`,
    kind: CARD_KINDS.HAZARD,
    hazard,
  }))
));

export const artifactCards = () => Array.from({ length: ARTIFACT_COUNT }, (_, i) => ({
  id: `a${i}`,
  kind: CARD_KINDS.ARTIFACT,
}));

/**
 * p1: "30 Quest cards, 15 Treasure cards and 15 Hazard cards".
 *
 * The Artifacts are NOT part of this - they enter one per round (p2), so they
 * are dealt separately by the setup code.
 */
export const questCards = () => [...treasureCards(), ...hazardCards()];

const byId = new Map([...questCards(), ...artifactCards()].map((card) => [card.id, card]));

export const cardById = (id) => byId.get(id) || null;

export const isTreasure = (card) => card?.kind === CARD_KINDS.TREASURE;
export const isHazard = (card) => card?.kind === CARD_KINDS.HAZARD;
export const isArtifact = (card) => card?.kind === CARD_KINDS.ARTIFACT;

/**
 * Where this card's face sits on the mod's 10x7 card sheet.
 *
 * Read off the sheet by eye once and encoded here rather than assumed: the
 * 35 faces run treasures (15, in the printed value order), then artifacts
 * (5), then hazards grouped by type in the order given by HAZARDS.
 * scripts/extractCardArt.mjs is the only consumer.
 */
export const sheetIndexOf = (card) => {
  if (isTreasure(card)) return Number(card.id.slice(1));
  if (isArtifact(card)) return TREASURE_VALUES.length + Number(card.id.slice(1));
  const type = HAZARDS.indexOf(card.hazard);
  const copy = Number(card.id.slice(card.hazard.length));
  return TREASURE_VALUES.length + ARTIFACT_COUNT + type * COPIES_PER_HAZARD + copy;
};
